import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "nome",
      "label-for": "nome",
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autofocus": "",
      "placeholder": "Nome da varia\xE7\xE3o ".concat(_vm.form.utiliza_cor ? '(Ex: Cor)' : '(Ex: Tamanho)')
    },
    model: {
      value: _vm.form.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nome", $$v);
      },
      expression: "form.nome"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "aparecerCores",
      "label-for": "aparecerCores",
      "label": "Utilizar exibição de cores"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.form.utiliza_cor
    },
    on: {
      "change": _vm.handleCheckboxColor
    }
  }), _c('span')])])])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "variaveis",
      "label-for": "variaveis",
      "label": "Variáveis"
    }
  }, _vm._l(_vm.form.variaveis, function (variavel, index) {
    return _c('div', {
      key: variavel.nome,
      staticClass: "d-flex align-items-center mb-3",
      staticStyle: {
        "gap": "10px"
      }
    }, [_vm.form.utiliza_cor ? _c('b-form-input', {
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "type": "color"
      },
      model: {
        value: variavel.cor,
        callback: function callback($$v) {
          _vm.$set(variavel, "cor", $$v);
        },
        expression: "variavel.cor"
      }
    }) : _vm._e(), _c('b-form-input', {
      attrs: {
        "autofocus": "",
        "placeholder": _vm.form.utiliza_cor ? 'Ex: Preto' : 'Ex: GG'
      },
      model: {
        value: variavel.nome,
        callback: function callback($$v) {
          _vm.$set(variavel, "nome", $$v);
        },
        expression: "variavel.nome"
      }
    }), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Excluir',
        expression: "'Excluir'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
      staticStyle: {
        "min-width": "30px"
      },
      on: {
        "click": function click($event) {
          return _vm.excluir(index);
        }
      }
    }, [_c('TrashCanIcon', {
      attrs: {
        "size": 20
      }
    })], 1)], 1);
  }), 0)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('button', {
    ref: "submit_nova_variacao",
    staticClass: "btn btn-secondary font-weight-bold border border-primary",
    on: {
      "click": _vm.addVariavel
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "gap": "5px"
    }
  }, [_c('Plus', {
    attrs: {
      "size": 20
    }
  }), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Adicionar mais")])], 1)])]), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.importarTemplate",
      modifiers: {
        "importarTemplate": true
      }
    }],
    ref: "import",
    staticClass: "btn btn-secondary font-weight-bold border border-primary"
  }, [_c('div', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "gap": "5px"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Importar exemplo")])])])])], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_nova_variacao",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'variacoes'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])]), _c('b-modal', {
    attrs: {
      "id": "importarTemplate",
      "title": "Importar exemplo",
      "size": "md",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.importarTemplate
          }
        }, [_vm._v(" Importar ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "mx-auto"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Exemplo"
    }
  }, [_c('b-form-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: _vm.selectedTemplate,
      callback: function callback($$v) {
        _vm.selectedTemplate = $$v;
      },
      expression: "selectedTemplate"
    }
  }, _vm._l(_vm.templatesExamples, function (template) {
    return _c('b-form-select-option', {
      key: template.nome,
      attrs: {
        "value": template
      }
    }, [_vm._v(" " + _vm._s(template.nome) + " ")]);
  }), 1)], 1), !!_vm.selectedTemplate ? _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "variaveis",
      "label-for": "variaveis",
      "label": "Variaveis"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.selectedTemplate.variaveis.map(function (el) {
    return el.nome;
  }).join(', ')))])])], 1)], 1) : _vm._e()], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };